import GetWidgetEventRegistrationQuestionsRequestModelBase from '../_generated/modelBases/get-widget-event-registration-questions-request-model-base';

export default class GetWidgetEventRegistrationQuestionsRequestModel extends GetWidgetEventRegistrationQuestionsRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
